import { render, staticRenderFns } from "./My-Account.vue?vue&type=template&id=2d4f4b45&scoped=true&"
import script from "./My-Account.vue?vue&type=script&lang=js&"
export * from "./My-Account.vue?vue&type=script&lang=js&"
import style0 from "./My-Account.vue?vue&type=style&index=0&id=2d4f4b45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4f4b45",
  null
  
)

export default component.exports